import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31c81a66"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleCard: require('/home/runner/work/marketing/marketing/components/ArticleCard.vue').default,Carousel: require('/home/runner/work/marketing/marketing/components/Carousel.vue').default})
